<template>
    <rkm-modal
        large
        ref="Modal"
        title="Parametrização de profissional assinatura eletrônica"
    >
        <Form
            :data="data"
            :index="index"
            :item="item"
            @save="handleExit"
            ref="Form"
        />

        <template v-slot:footer="{ cancel }">
            <rkm-button @click="cancel">
              Fechar
            </rkm-button>

            <rkm-button
                @click="handleSave"
                color="primary"
            >
                {{ index == null ? 'Incluir' : 'Alterar' }}
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Components.
import Form from './Form'

export default {
    components: { Form },
    data: () => ({
        index: null,
        item: null
    }),
    methods: {
        open(index, item) {

            this.index = index
            this.item = item

            this.$refs.Modal.show()
        },
        handleExit(data) {

            this.$emit('save', data)
            this.$refs.Modal.hide()
        },
        handleSave() {

            this.$refs.Form.save()
        },
    },
    props: {
        data: { type: Object, required: true },
    }
}
</script>